const upgradePersonal = {
  bannerTitle: 'HitPaw在线终极版',
  introduct:
    '获得工具集中超过35种功能的会员高级权益，包括增强器、移除器、AI 翻译器、屏幕录制器等，只需一次即可获得，价格实惠。',
  Tools: '工具包',
  Upgrade: '升級',
  MyProjects: '我的文件',
  MyAccount: '我的账户',
  Subscription: '订阅',
  LogOut: '登出',
  PopularTools: '流行工具',
  Enhance: '增强（图片增强+视频增强）',
  Remove: '去除（图片去水印+视频去水印+TikTok去水印）',
  Animate: '动起来（动态老照片）',
  Extract: '提取（音频提取）',
  SaveThreeDays: '项目保存3天，请处理后下载。',
  All: '全部',
  Video: '视频',
  Image: '图像',
  Audio: '声音的',
  minutesAgo: '几分钟前',
  hoursAgo: '几小时前',
  daysAgo: '几天前',
  Modified: '修改的',
  Order: '排序',
  EarliestToLatest: '最早到最新',
  LatestToEarliest: '从最新到最早',
  NoProject: '没有项目。 快速开始',
  OnlineTools: '在线工具。',
  AIVideoEnhancer: '人工智能视频增强器',
  Enhancer4K: '一键AI在线增强视频至4K',
  AIPhotoEnhancer: '人工智能照片增强器',
  AIEnhancerImage: 'AI 在线无损增强图像高达8倍',
  View: '查看（文件）',
  Download: '下载',
  MultipleSelect: '多选',
  Delete: '删除',
  SubscriptionHistory: '订阅历史',
  NoValidSubscription: '没有有效的订阅。',
  veContent: '一键AI在线增强视频至4K',
  peContent: 'AI 在线无损增强图像高达 8 倍',
  rmvContent: '去除视频水印',
  rmttContent: '瞬间去除TikTok视频水印',
  dynamicContent: '在线为您的照片制作动画',
  rmbgContent: '从图像中删除背景',
  youMayNeed: '你可能需要',
  new: '新',
  loginYourAccount: '登录您的 HitPaw 帐户',
  signUpYourAccount: '注册您的 HitPaw 帐户',

  HitPawWatermark: 'HitPaw 在线水印去除器',
  HitPawTiktokWatermark: 'HitPaw 在线 TikTok 水印去除器',
  HitPawRemoveBg: 'HitPaw 在线背景去除剂',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
